import { post } from '@/utils/request'

export default {
    // 公司基础信息
    base(data) {
        return post('/index/getBasic.html',data)
    },
    // 表单提交
    message(data){
        return post('/msg/add.html',data)
    }
}